export default __webpack_public_path__ + "static/media/brasilio.89e7a786.png";